import React from "react";

const ContigentStaffing = () => {
  return (
    <section className="min-h-screen flex items-center justify-center p-6 pt-16 bg-gray-100 ">
      <article className="bg-transparent shadow-lg rounded-2xl p-8 w-full max-w-3xl">
        <header className="text-center mb-6">
          <h2 className="text-3xl font-bold text-blue-600">
            Contingent Staffing Solutions – India, USA & Canada
          </h2>
        </header>

        <section className="mb-6">
          <p className="text-gray-700">
            <b>Talennect</b> provides{" "}
            <b>AI-powered contingent staffing solutions</b> across{" "}
            <b>India, the USA, and Canada</b>, enabling businesses to adapt
            quickly to evolving workforce needs. Our advanced recruitment
            strategies leverage{" "}
            <b>
              artificial intelligence, data-driven insights, and an extensive
              talent network
            </b>{" "}
            to source highly skilled professionals for temporary, contract, and
            project-based roles.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Agile Workforce Solutions
          </h3>
          <p className="text-gray-700">
            In today’s fast-paced business environment, companies require{" "}
            <b>agile workforce solutions</b> to remain competitive. Talennect
            streamlines the hiring process by identifying top talent that aligns
            with your organizational goals, ensuring{" "}
            <b>
              faster placements, reduced hiring costs, and enhanced workforce
              efficiency
            </b>
            . Our contingent staffing services cater to various industries,
            including <b>IT, engineering, healthcare, finance, and more</b>.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Pre-Vetted Talent
          </h3>
          <p className="text-gray-700">
            With our <b>cutting-edge technology and industry expertise</b>, we
            help clients fill critical roles with{" "}
            <b>pre-vetted, highly qualified professionals</b> who drive
            productivity and innovation. Whether you need specialized IT
            experts, temporary project teams, or skilled professionals for
            seasonal demands, Talennect ensures{" "}
            <b>seamless workforce integration</b> without long-term hiring
            commitments.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Global Reach & Compliance
          </h3>
          <p className="text-gray-700">
            Our <b>global reach</b> and localized expertise across{" "}
            <b>India, the USA, and Canada</b> allow us to navigate regional
            employment regulations, ensuring{" "}
            <b>compliance and risk mitigation</b> while delivering high-quality
            staffing solutions. We take pride in offering{" "}
            <b>customized hiring strategies</b> that empower businesses to{" "}
            <b>
              scale efficiently, optimize workforce planning, and achieve
              operational success
            </b>
            .
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-blue-600">
            Partner with Talennect Today
          </h3>
          <p className="text-gray-700">
            Let <b>Talennect</b> be your strategic staffing partner, helping you
            build a dynamic, future-ready workforce. Contact us to explore how
            our <b>AI-driven contingent staffing</b> solutions can enhance your
            business growth and workforce agility.
          </p>
        </section>
      </article>
    </section>
  );
};

export default ContigentStaffing;
